export default function Bookings() {
  return (
    <div>
      <div className="section-header">
        <h1>Booking an ice skating lesson</h1>
      </div>
      <div>
        <p>Currently my only available timeslots are Friday and Sunday.</p>
        <p>Pricing: £30 for 30 minutes, discounted to £50 for a full hour.</p>
        <p>
          Send me over an email with your preferred day and time, and any other
          questions you might have for me. I'll get back to you as soon as I can
          🙂. Feel free to leave a contact number if you'd rather a text or
          phone call too!{" "}
        </p>
        <a href="mailto:chantelle@coachchantelle.app">
          chantelle@coachchantelle.app
        </a>
      </div>
    </div>
  );
}
